import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';
import { IMAGE_BASE__URL } from '../../core/services/CusHttp';
import { Router } from '@angular/router';

@Component( {
  selector: 'course-fit',
  templateUrl: './course-fit.component.html',
  styleUrls: [ './course-fit.component.scss' ]
} )
export class CourseFitComponent implements OnInit {
  fitCourses: any = [];
  IMAGE_BASE__URL = IMAGE_BASE__URL;
  constructor(
    private _service: SharedService,
    private _router: Router
  ) { }

  ngOnInit() {

    //获取适合你的课程
    this._service.getHotCourse( null, 8 ).then( data => {
      if ( data[ 'data' ] && data[ 'data' ].length > 0 ) {
        this.fitCourses = data[ 'data' ];
      }
    } );
  }

  //跳转课程详情
  gotoDetail( id: any ) {
   this._router.navigate(['/station/coudetail', id]);
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/course-fit/course-fit.component.ts